import "./styles.css";
import { GoThreeBars } from "react-icons/go";
import { useEffect, useRef, useState } from "react";
import Child from "./Child";
import { compact, repeat, uniq } from "lodash";
import Cartitem from "./CartItem";

export default function App() {
  const [show, setShow] = useState(false);
  const [count, setCount] = useState(0);
  const [obj, setObj] = useState({});
  const [keyy, setKey] = useState("");
  const [valuee, setValue] = useState("");
  const [search, setSearch] = useState("");
  const [addedproduct, setAddedproduct] = useState([]);

  // Ecommerce design
  const [dataProduct, setProductData] = useState([]);
  const [totalCart, setTotalCart] = useState(0);

  useEffect(() => {
    fetchDa();
  }, []);

  useEffect(() => {
    console.log("dataProdict come");
    dataProduct.forEach((item) => {
      item.added = false;
    });
  }, [dataProduct]);

  const fetchDa = async () => {
    console.log("Fetch data");
    const fetchData = await fetch("https://fakestoreapi.com/products");
    const dataa = await fetchData.json();
    setProductData(dataa);
  };

  const mapData = () => {
    const dataa = dataProduct.map((item, index) => {
      return (
        <>
          <div
            style={{
              maxWidth: "100%",
              maxHeight: "100%",
              height: "166px",
              padding: "25px 15px",
              margin: "1em",
              display: "inline-block",
              boxShadow:
                "rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px"
            }}
          >
            <div style={{ textAlign: "center" }}>
              <img loading="lazy" height={50} width={50} src={item.image} />
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-evenly",
                gap: "1em"
              }}
            >
              <span title={item.title} className="titleClass">
                {item.title}
              </span>
              <b>${item.price}</b>
            </div>
            <div>
              <button
                onClick={() =>
                  item.added
                    ? removeFromCart(item.price, index, item)
                    : addToCart(item.price, index, item)
                }
                style={{
                  width: "100%",
                  backgroundColor: item.added ? "red" : "green",
                  color: "white",
                  padding: "0.7em",
                  border: "none",
                  borderRadius: "0.3em",
                  margin: "12px 0px 11px 0px"
                }}
              >
                {" "}
                {item.added ? "Remove from cart" : "Add to cart"}
              </button>
            </div>
          </div>
        </>
      );
    });

    return dataa;
  };

  // add to cart logic
  let priceArr = [];
  const addToCart = (price, ind, dataObj) => {
    addedproduct.push(dataObj);
    dataProduct.forEach((item, index) => {
      dataProduct[ind].added = true;
    });
    setProductData(dataProduct);
    priceArr.push(...priceArr, price);
    const priceArrUniq = uniq(priceArr);
    const cartValue = priceArrUniq.reduce((curr, accum) => {
      return curr + accum;
    }, 0);
    setTotalCart((prev) => cartValue + prev);
  };

  // Remove from cart
  const removeFromCart = (price, ind, dataObj) => {
    const filterItemArr = addedproduct.filter((item, ind) => {
      return item.id !== dataObj["id"];
    });
    setAddedproduct(filterItemArr);
    dataProduct.forEach((item, index) => {
      dataProduct[ind].added = false;
    });
    setProductData(dataProduct);

    setTotalCart((prev) => prev - price);
    console.log("rem", dataProduct);
  };

  // search product by name
  const searchBuyName = (e) => {
    setSearch(e.target.value);
    const result = compact(
      dataProduct.map((item) => {
        const name = item.category || "";
        const flag =
          name.toLowerCase().includes(search.toLowerCase()) || search === "";
        if (flag) {
          return item;
        }
        return null;
      })
    );
    setProductData(result);
  };

  useEffect(() => {
    if (true) {
      setCount(count + 1);
    }
  }, []);

  // add dynamic key value in object

  const addProp = () => {
    setObj({ ...obj, [keyy]: valuee });
  };
  // const funcChild = (count) => {
  //   setShow(count);
  // };
  const refinput = useRef(null);
  return (
    <>
      <div className="App">
        {/* <span className="imgDiv">
        <img src="#" alt="img" />
        </span> */}
        <div className="navigation">
          <div>
            <ul className={show ? "active" : "listUl"}>
              <li className="listLI">Home</li>
              <li className="listLI">About us</li>
              <li className="listLI">Contact</li>
            </ul>
          </div>
        </div>
        {console.log(dataProduct)}
        <GoThreeBars
          onClick={() => {
            setShow(!show);
          }}
        />
      </div>
      <input
        value={keyy}
        onChange={(e) => {
          setKey(e.target.value);
        }}
      />
      <input ref={refinput} placeholder="ref" />
      <button
        onClick={() => {
          refinput.current.value = "heyyy";
          console.log("refinput.current.value", refinput.current.value);
        }}
      >
        Ref
      </button>
      <input
        value={valuee}
        onChange={(e) => {
          setValue(e.target.value);
        }}
      />
      <button onClick={addProp}>Add property</button>
      <input
        onChange={searchBuyName}
        placeholder="Search product"
        value={search}
      />
      <div className="cartTotalClass">
        {" "}
        <h3>Cart total:{totalCart.toFixed(2)} </h3>
        <h3>E-Commerce</h3>
      </div>
      {/* <Child fromChild={funcChild} /> */}
      {/* {show} */}
      <div style={{ display: "flex" }}>
        <div
          style={{
            width: "100%",
            display: "grid",
            gridTemplateColumns: " repeat( auto-fit, minmax(250px, 1fr) )",
            gridTemplateRows: "repeat(3,1fr)"
          }}
        >
          {mapData()}
        </div>
        {/* border: 1px solid black;
    width: 100vw;
    max-width: 500px;
    max-height: 100%;
    background: grey; */}
        <div
          style={{
            width: "100vw",
            maxHeight: "100%",
            maxWidth: "300px",
            background: "lightgrey"
          }}
        >
          {addedproduct.length > 0 ? (
            <Cartitem itemArray={addedproduct} />
          ) : (
            <p style={{ textAlign: "center" }}>Cart is empty!</p>
          )}
        </div>
      </div>
    </>
  );
}
